import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, GUEST_ALL, GUEST_LIST } from '../constants/actionTypes'

const guestSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const guestAllSelector = createSelector(guestSelector, data => data[GUEST_ALL])

export const guestListSelector = createSelector(guestSelector, data => data[GUEST_LIST])
